module.exports = __webpack_public_path__ + "img/compliance3.afc85df1.svg";